import { createErrorState, createLoadingState, createSuccessState } from 'app/store/app/app.models';
import {
  getMetricCharts,
  getMetricChartsSuccess,
  getMetricChartsError,
  getMetricData,
  getMetricDataSuccess,
  getMetricDataError,
  getMetricDefinitions,
  getMetricDefinitionsSuccess,
  getMetricDefinitionsError,
} from 'app/store/app-monitoring/app-monitoring.actions';
import { initialMonitoringState } from 'app/store/app-monitoring/app-monitoring.state';
import { createReducer, on } from '@ngrx/store';

export const appMonitoringReducer = createReducer(
  initialMonitoringState,
  on(getMetricDefinitions, (state, action) => ({
    ...state,
    metricDefinitions: createLoadingState(state.metricDefinitions),
  })),
  on(getMetricDefinitionsSuccess, (state, { metricDefinitions }) => ({
    ...state,
    metricDefinitions: createSuccessState(metricDefinitions),
  })),
  on(getMetricDefinitionsError, (state, { error }) => ({
    ...state,
    metricDefinitions: createErrorState(error, []),
  })),
  on(getMetricCharts, (state) => ({
    ...state,
    metricCharts: createLoadingState(state.metricCharts),
  })),
  on(getMetricChartsSuccess, (state, { metricCharts }) => ({
    ...state,
    metricCharts: createSuccessState(metricCharts),
  })),
  on(getMetricChartsError, (state, { error }) => ({
    ...state,
    metricCharts: createErrorState(error, []),
  })),
  on(getMetricData, (state) => ({
    ...state,
    chartData: createLoadingState(state.chartData),
  })),
  on(getMetricDataSuccess, (state, { chartData }) => ({
    ...state,
    chartData: createSuccessState(chartData),
  })),
  on(getMetricDataError, (state, { error }) => ({
    ...state,
    chartData: createErrorState(error, null),
  }))
);